<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">Publicação</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="px-3 py-0">
          <div class="pb-1">Criado em: {{ model.f_created }}</div>
          <div class="pb-1">Atualizado em: {{ model.f_updated }}</div>
        </d-list-group-item>
        <d-list-group-item class="p-3">
          <d-button
            v-if="model.id"
            @click="toggleStatus"
            :class="isPuzzleStatusCompleted(gameStatus) ? 'btn-outline-warning' : 'btn-outline-success'"
            class="btn-block mb-2"
          >
            {{ isPuzzleStatusCompleted(gameStatus) ? 'Mudar para Rascunho' : 'Finalizar Jogo' }}
          </d-button>
          <d-button
            :disabled="!canExport"
            @click.prevent="toggleExportModal()"
            class="btn-dark btn-block"
          >
            Exportar
          </d-button>
          <p
            v-if="!canExport"
            class="text-muted mb-1 small"
            style="color: #6c757d !important"
          >
            Você precisa salvar antes de exportar.
          </p>
          <d-button
            @click="generateBank"
            class="btn-outline-light border btn-block"
          >
            Gerar banco de respostas
          </d-button>

          <d-button
            v-if="model.settings.bank?.length > 0"
            @click="clearBank"
            class="btn-outline-light border btn-block"
          >
            Limpar banco de respostas
          </d-button>
          <d-button
            @click="openImportModal"
            class="btn-outline-light border btn-block"
          >
            <i class="material-icons">cloud_upload</i> Importar Arquivo
          </d-button>
          <d-button
            @click="openSaveTemplateModal"
            class="btn-outline-light border btn-block"
          >
            Salvar como Template
          </d-button>
          <d-button
            @click.prevent="generateNewFromCurrentTemplate()"
            class="btn-info btn-block mt-2"
            :disabled="isGenerating || !hasAnyLetter"
          >
            Salvar e Gerar novo Jogo
          </d-button>
          <p
            v-if="!hasAnyLetter"
            class="text-muted mb-0 small mb-2"
          >
            O grid está sem palavras. Insira novas para habilitar.
          </p>
          <d-button
            @click.prevent="fillCrossword()"
            class="btn-dark btn-block"
            :disabled="hasNoQuestions"
          >
            Inserir Palavras
          </d-button>
          <p
            v-if="hasNoQuestions"
            class="text-muted mb-0 small"
          >
            Sinalize pelo menos uma pergunta no grid.
          </p>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>

    <d-card-footer
      class="border-top d-flex flex-column flex-xl-row justify-content-around"
    >
      <d-button
        @click="save"
        type="button"
        class="btn-primary mb-3 mb-xl-0 col-xl-5"
      >
        Salvar
      </d-button>
      <router-link
        class="btn-secondary btn text-white col-xl-5"
        :to="{ name: 'admin-crossword-list', params: { page: 1 } }"
      >
        Cancelar
      </router-link>
    </d-card-footer>
    <export-file-modal
      gameType="crossword"
      :items="[model]"
      :fileName="model.name || 'crossword'"
    />
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import ExportFileModal from '_common/shared/ExportFileModal.vue';
import { MODEL, isPuzzleStatusCompleted, STATUS } from './PuzzleModel';

export default {
  name: 'sidebar-actions',
  props: {
    model: {
      type: Object,
      default: () => MODEL,
    },
    isGenerating: {
      type: Boolean,
      default: false,
    },
  },
  components: { ExportFileModal },
  computed: {
    gameStatus() {
      return this.model.status;
    },
    canExport() {
      const { hasChanges } = this.$store.state.puzzle;
      const isPageCreation = !this.$route.params.puzzleId;

      if (isPageCreation) return false;
      if (hasChanges) return false;

      return true;
    },
    hasNoQuestions() {
      return !this.model.table.some(cell => cell.isQuestion);
    },
    hasAnyLetter() {
      return this.model.table.some(cell => cell.text && cell.text.trim() !== '');
    },
  },
  methods: {
    ...mapActions(['setToggle']),
    isPuzzleStatusCompleted,
    toggleStatus() {
      const newStatus = isPuzzleStatusCompleted(this.gameStatus) ? STATUS.DRAFT : STATUS.COMPLETED;
      this.$emit('changeStatus', newStatus);
    },
    goBack() {
      this.$router.go(-1);
    },
    generate() {
      this.$emit('generate', this.model);
    },
    fillCrossword() {
      this.$emit('fillCrossword');
    },
    generateNewFromCurrentTemplate() {
      this.$emit('generateNewFromCurrentTemplate');
    },
    generateBank() {
      this.$emit('generateBank');
    },
    clearBank() {
      this.$emit('clearBank');
    },
    save() {
      this.$emit('save', this.model);
    },
    toggleModal() {
      this.setToggle({ type: 'export_file_modal', bool: true });
    },
    openImportModal() {
      this.setToggle({ type: 'import_file_modal', bool: true });
    },
    toggleExportModal() {
      this.setToggle({ type: 'export_file_modal', bool: true });
    },
    openSaveTemplateModal() {
      this.setToggle({ type: 'save_template_modal', bool: true });
    },
  },
};
</script>
